(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignIntegrationForm', {
    bindings: {
      existingIntegrationSetting: '<',
      jsTags: '<',
      affiliateNumbers: '<',
      allIntegrations: '<',
      onUpdate: '&',
      onDismiss: '&'
    },
    controller: CampaignIntegrationFormController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/campaign-integration/campaign-integration-form/campaign-integration-form.view.html'
  });

  function CampaignIntegrationFormController(
    $q,
    accountsService,
    bsLoadingOverlayService,
    integrationService,
    toaster,
    utils
  ) {
    'ngInject';

    const vm = this;

    vm.events = [
      {
        label: 'Conversion',
        value: 'converted'
      },
      {
        label: 'Payout',
        value: 'payout'
      }
    ];
    vm.loadConversionSetsRefId = 'conversionSetsLoader';

    vm.integrationWith = 'number';
    vm.defaultDelayTime = 5;
    vm.createNewConversionSet = false;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.handleSubmit = handleSubmit;
    vm.onIntegrationChange = onIntegrationChange;
    vm.cancel = cancel;
    vm.changeDefaultDelayTime = changeDefaultDelayTime;
    vm.handleIntegrationWithChange = handleIntegrationWithChange;
    vm.handleCreateNewToggleChange = handleCreateNewToggleChange;

    function onInit() {
      vm.isAffiliate = accountsService.isAffiliate();

      if (vm.isAffiliate) {
        vm.events = [
          {
            label: 'Payout',
            value: 'payout'
          }
        ];

        vm.numberIntegration = vm.numberIntegration || {};
        vm.numberIntegration.eventCode = 'payout';
      }

      if (vm.existingIntegrationSetting) {
        _setFormVariablesFromExisting(vm.existingIntegrationSetting);
      }

    }

    function onChanges(changes) {
      if (changes.jsTags) {
        vm.jsTagsList = angular.copy(vm.jsTags);
      }
      if (changes.existingIntegrationSetting) {
        changeDefaultDelayTime();
      }
    }

    function handleIntegrationWithChange() {
      _changeConversionSetFilter();
      changeDefaultDelayTime();
    }

    function changeDefaultDelayTime() {
      let provider = 'default',
        type = 'default';

      if (vm.selectedIntegration) {
        provider = vm.selectedIntegration.type;
        type = vm.integrationWith;
      }

      if (vm.existingIntegrationSetting && vm.existingIntegrationSetting.integration) {
        provider = vm.existingIntegrationSetting.integration.type;
        type = vm.existingIntegrationSetting.callerIdOnlyConversion ? 'number' : 'jstag';
      }

      vm.defaultDelayTime = integrationService.getDefaultDelayTime(provider, type);
    }

    function handleSubmit(integration, numberIntegration) {
      if (vm.existingIntegrationSetting) {
        return _updateIntegrationSetting(integration, numberIntegration);
      } else {
        return _createIntegrationSetting({
          integration: integration,
          numberIntegration: numberIntegration,
          numberIds: vm.numbersToAdd,
          jsTagId: vm.selectedJsTag && vm.selectedJsTag.id,
          campaignId: vm.selectedJsTag && vm.selectedJsTag.campaignId
        });
      }
    }

    function cancel() {
      vm.onDismiss();
    }

    function onIntegrationChange() {
      changeDefaultDelayTime();
      _getConversionSetsOrPixels(vm.selectedIntegration);
      _changeConversionSetFilter();
    }

    function handleCreateNewToggleChange(createNew) {
      vm.numberIntegration = vm.numberIntegration || {};

      if (!createNew && vm.existingIntegrationSetting) {
        vm.numberIntegration.conversionSet = vm.existingIntegrationSetting.conversionSet;
      } else {
        vm.numberIntegration.conversionSet = undefined;
      }
    }

    function _changeConversionSetFilter() {
      vm.filterConversionSet = undefined;
    }

    function _getConversionSetsOrPixels(integration) {
      if (!integration) {
        return;
      }

      let functionCalled;
      if (integration.type == 'facebookEvents') {
        functionCalled = integrationService.getFbPixels(accountsService.currentAccountId, integration).then(function (response) {
          vm.fbPixels = response.data.pixels;
        });
      } else {
        functionCalled = integrationService.getIntegrationConversionSets(accountsService.currentAccountId, integration).then(function (response) {
          vm.conversionSets = response.data.conversionSets;
        });
      }

      _showLoader(vm.loadConversionSetsRefId);
      vm.loadingConversionSetsForIntegration = true;

      return functionCalled.catch(utils.errorHandler)
        .finally(function () {
          _hideLoader(vm.loadConversionSetsRefId);
          vm.loadingConversionSetsForIntegration = false;
        });
    }

    function _updateIntegrationSetting(integration, numberIntegration) {
      return integrationService.updateIntegrationSetting(accountsService.currentAccountId, vm.existingIntegrationSetting.id, integration, {
        eventCode: numberIntegration.eventCode,
        integrationType: integration.type,
        offlineUploadDelay: numberIntegration.offlineUploadDelay,
        conversionSet: numberIntegration.conversionSet,
        pixelId: numberIntegration.pixelId,
      }).then(function () {
        vm.onUpdate();
        toaster.pop('success', 'Successfully updated the number integration settings.');
      }).catch(utils.errorHandler);
    }

    function _createIntegrationSetting(data) {
      if (vm.integrationWith === 'number') {
        return _createIntegrationSettingForNumber(data);
      } else if (vm.integrationWith === 'jstag') {
        return _createIntegrationSettingForJsTag(data);
      }

      return $q.when();
    }

    function _createIntegrationSettingForNumber(data) {
      return integrationService.setNumberWithConversionSet(accountsService.currentAccountId, data.integration, {
        numberIds: data.numberIds,
        eventCode: data.numberIntegration.eventCode,
        adCampaignName: data.numberIntegration.campaignName,
        offlineUploadDelay: data.numberIntegration.offlineUploadDelay,
        conversionSet: data.numberIntegration.conversionSet,
        pixelId: data.numberIntegration.pixelId
      }).then(function (response) {
        const message = _getSuccessMessage(response.data.numbersWithErrors);
        toaster.pop({
          type: 'success',
          body: message
        }, message);
        vm.onUpdate();
      }).catch(utils.errorHandler);
    }

    function _createIntegrationSettingForJsTag(data) {
      return integrationService.setJsTagWithConversionSet(accountsService.currentAccountId, data.integration, {
        jsTagId: data.jsTagId,
        eventCode: data.numberIntegration.eventCode,
        offlineUploadDelay: data.numberIntegration.offlineUploadDelay,
        campaignId: data.campaignId,
        conversionSet: data.numberIntegration.conversionSet,
        pixelId: data.numberIntegration.pixelId,
      }).then(function () {
        toaster.pop('success', 'Successfully associated JS Tag with the selected Ad campaign');
        vm.onUpdate();
      }).catch(utils.errorHandler);
    }

    function _setFormVariablesFromExisting(integrationSetting) {
      vm.numberIntegration = {
        campaignName: integrationSetting.integration.type === 'facebook' ? undefined : integrationSetting.campaignName,
        conversionSet: angular.copy(integrationSetting.conversionSet),
        eventCode: integrationSetting.eventCode,
        pixelId: integrationSetting.configuration && integrationSetting.configuration['pixelId'],
        offlineUploadDelay: integrationSetting.configuration && parseInt(integrationSetting.configuration['offlineUploadDelay'])
      };

      vm.selectedIntegration = integrationSetting.integration;

      vm.integrationWith = integrationSetting.jsTagId ? 'jstag' : 'number';

      _showOrHideAdEditForm(integrationSetting);

      _getConversionSetsOrPixels(vm.selectedIntegration);

      vm.createNewConversionSet = false;
    }

    // Show or hide the Ad edit form
    // For FB the user should open the Ad edit form, only if he wants to change the Ad
    // Because it's 3 step process to select an Ad for FB
    function _showOrHideAdEditForm(integrationSetting) {
      if (vm.selectedIntegration.type === 'facebook') {
        vm.showFbEditForm = false;
        vm.facebookAd = {
          id: integrationSetting.configuration['facebookAdId'],
          name: integrationSetting.configuration['facebookAdName']
        };
      } else {
        vm.showFbEditForm = true;
      }
    }

    function _getSuccessMessage(numbersWithErrors) {
      if (numbersWithErrors && numbersWithErrors.length) {
        return 'Some numbers which were not associated with an ad-campaign: ' + numbersWithErrors.join(', ');
      }
      return 'Successfully associated the ad-campaign with the selected numbers';
    }

    function _showLoader(refId) {
      bsLoadingOverlayService.start({
        referenceId: refId
      });
    }

    function _hideLoader(refId) {
      bsLoadingOverlayService.stop({
        referenceId: refId
      });
    }

  }
})();
